import { createPinia } from "pinia";
import { createApp } from "vue";
import "element-plus/theme-chalk/el-message-box.css";
import "element-plus/theme-chalk/el-message.css";
import App from "./App.vue";
import router from "./router";
import "./assets/styles/cruise-pms-tokens.css";
// Resolve the configured font stack locally; full CJK fonts add ~21 MB of downloads.
import "./assets/styles/cruise-pms-element.scss";
import "./assets/styles/cruise-pms-components.scss";
import "./assets/styles/app.scss";
import "./assets/styles/mobile.scss";
import { initializeH5Mode } from "./utils/h5-mode";

initializeH5Mode();
createApp(App).use(createPinia()).use(router).mount("#app");
